import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeNotifications, setNotificationsRead } from "actions/notificationActions";
import { getDashboardActions } from "actions/dashboardActionsPP";
import messages from "../messagesDescription";
import { injectIntl, intlShape } from "react-intl";
import { formatDateTime } from "../../i18n/util";

const NotificationPage = ({ history, intl }) => {
  const dispatch = useDispatch();
  const employeeNotifications = useSelector(state => state.notification.employeeNotifications);

  const count = 60,
    page = 1,
    pageSize = 999;

  useEffect(() => {
    dispatch(getEmployeeNotifications(count, page, pageSize));
  }, []);

  const handleReadNotification = (index, notificationId, route) => {
    dispatch(setNotificationsRead(notificationId));
    dispatch(getEmployeeNotifications(count, page, pageSize));
    dispatch(getDashboardActions());
    history.push(route.toLowerCase());
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        margin: 20,
      }}
    >
      <h4 style={{ color: "#000000", fontWeight: "bold" }}>
        {intl.formatMessage(messages.notificationsLabel)}
      </h4>
      <p>{intl.formatMessage(messages.recentNotificationsLabel)}</p>
      {employeeNotifications && employeeNotifications.notifications.length <= 0 && (
        <p className="notifications-label">{intl.formatMessage(messages.noNotificationLabel)}</p>
      )}
      {employeeNotifications &&
        employeeNotifications.notifications.map((item, index) => (
          <div
            key={item.pkPushNotification}
            role="button"
            tabIndex={index}
            onClick={() =>
              handleReadNotification(index, item.pkPushNotification, item.redirectModule)
            }
            onKeyDown={() =>
              handleReadNotification(index, item.pkPushNotification, item.redirectModule)
            }
            style={{
              backgroundColor: "#fff",
              width: "80%",
              padding: 20,
              margin: 2,
              border: "solid",
              borderWidth: "2px",
              borderColor: !item.read ? "#0E6DBE" : "gray",
              borderRadius: 5,
              cursor: "pointer",
            }}
          >
            {<h4>{formatDateTime(item.createOn)}</h4>}
            {!item.read ? (
              <p>
                <strong>{item.title}</strong>
              </p>
            ) : (
              <p>{item.title}</p>
            )}
            <p>{item.content}</p>
          </div>
        ))}
    </div>
  );
};

NotificationPage.propTypes = {
  intl: intlShape.isRequired,
  history: PropTypes.object.isRequired,
};

export default injectIntl(NotificationPage);



// WEBPACK FOOTER //
// ./components/notifications/NotificationPage.jsx